export default {
	title: '传感器类型管理',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '操作成功',
		selectDeleteWarning: '请选择要删除的记录',
		operateSuccess: '操作成功',
		requiredFieldCannotBeEmpty: '必填项不能为空'
	},
	form: {
		name: '类型名称',
		axisCount: '轴数',
		upMode: '上行模式',
		placeholder: {
			name: '请输入类型名称',
			axisCount: '请选择轴数',
			upMode: '请选择上行模式'
		}
	},
	table: {
		id: 'ID',
		orgId: '机构',
		name: '类型名称',
		icon: '图标',
		axisCount: '轴数',
		upMode: '上行模式',
		sysEig: '特征值',
		sysWave: '波形'
	},
	dialog: {
		add: '新增',
		edit: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	widgetForm: {
		name: '类型名称',
		orgId: '所属机构',
		icon: '图标',
		upMode: '上行模式',
		characters: '特征值功能码',
		accelerate: '时域功能码',
		sysEig: '特征值',
		sysWave: '波形类型',
		toolTypeId: '诊断工具类型',
		axisCount: '轴数',
		gridLayout: '格栅布局',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		placeholder: {
			name: '请选择类型名称',
			orgId: '请选择机构',
			icon: '请选择图标',
			upMode: '请选择上行模式',
			characters: '请输入特征值功能码',
			accelerate: '请输入时域功能码',
			toolTypeId: '请选择诊断工具类型',
			axisCount: '请选择轴数'
		}
	}
}
